
import { defineComponent, PropType } from "vue";

import {
  ColumnDefinition,
  BaseButton,
  DeleteIcon,
  SouthIcon,
  BaseTable,
  NorthIcon,
  FormField,
  FormFieldComboBox,
  FormFieldCheckbox,
} from "@tager/admin-ui";

import {
  discountTypeOption,
  PriceMultipleValueInForm,
} from "@/views/ProductForm/ProductForm.helpers";
import DescriptionBlock from "@/views/ProductForm/components/DescriptionBlock.vue";

const COLUMN_DEFS: Array<ColumnDefinition> = [
  {
    id: 1,
    name: "Значение",
    field: "name",
  },
  {
    id: 2,
    name: "Цена",
    field: "price",
    style: { width: "150px" },
    headStyle: { width: "150px" },
  },
  {
    id: 3,
    name: "Скидка",
    field: "discount",
    style: { width: "230px" },
    headStyle: { width: "230px" },
  },
  {
    id: 4,
    name: "Итоговая цена",
    field: "total",
    style: { width: "115px", verticalAlign: "center", textAlign: "center" },
    headStyle: { width: "115px", whiteSpace: "nowrap" },
  },
  {
    id: 5,
    name: "",
    field: "actions",
    style: { width: "140px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "140px", textAlign: "center" },
  },
];

type Props = Readonly<{
  priceMultipleValues: Array<PriceMultipleValueInForm>;
}>;

export default defineComponent({
  name: "PriceTable",
  components: {
    DescriptionBlock,
    BaseButton,
    DeleteIcon,
    SouthIcon,
    BaseTable,
    NorthIcon,
    FormField,
    FormFieldComboBox,
    FormFieldCheckbox,
  },
  props: {
    priceMultipleValues: {
      type: Array as PropType<Props["priceMultipleValues"]>,
      required: true,
    },
  },
  setup(props) {
    function removeField(rowIndex: number) {
      props.priceMultipleValues.splice(rowIndex, 1);
    }

    function moveItem(itemIndex: number, direction: "up" | "down") {
      const itemList = props.priceMultipleValues;

      if (
        (direction === "up" && itemIndex === 0) ||
        (direction === "down" && itemIndex === itemList.length - 1)
      ) {
        return;
      }

      const item = itemList[itemIndex];

      itemList.splice(itemIndex, 1);
      itemList.splice(
        direction === "up" ? itemIndex - 1 : itemIndex + 1,
        0,
        item
      );
    }

    function resetDiscountValue(rowIndex: number) {
      props.priceMultipleValues[rowIndex].discountValue = "";
      document.getElementById(`[${rowIndex}][discountValue]`)?.focus();
    }

    function getDiscountPricePercent(price: number, discountValue: number) {
      return (price * (100 - discountValue)) / 100 >= 0
        ? (price * (100 - discountValue)) / 100
        : 0;
    }

    function getDiscountPriceValue(price: number, discountValue: number) {
      return price - discountValue >= 0 ? price - discountValue : 0;
    }

    return {
      columnDefs: COLUMN_DEFS,
      removeField,
      discountTypeOption,
      resetDiscountValue,
      moveItem,
      getDiscountPricePercent,
      getDiscountPriceValue,
    };
  },
});
